"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var fill = _a.fill;
    if (fill === undefined) {
        return '';
    }
    if (fill === 'horizontal') {
        return 'width: 100%;';
    }
    if (fill === 'vertical') {
        return 'height: 100%;';
    }
    if (fill === true) {
        return "\n      width: 100%;\n      height: 100%;\n    ";
    }
    return '';
});
